import Event from "sap/ui/base/Event";
import BaseController from "./BaseController";
import AuthService, { SSO_ERROR_STORAGE_KEY } from "../service/AuthService";

/**
 * @namespace com.ang.portal.controller
 */
export default class SsoCallback extends BaseController {
	private static readonly ROUTE_ARGUMENTS_PARAM = "arguments" as const;

	public onInit(): void {
		this.getRouter()
			.getRoute("ssoCallback")
			.attachPatternMatched((oEvent) => this.onRouteMatched(oEvent), this);
	}

	private onRouteMatched(
		oEvent: Event<{ arguments?: { token?: string } }>,
	): void {
		const token = oEvent.getParameter(
			SsoCallback.ROUTE_ARGUMENTS_PARAM,
		)?.token;

		void this.completeSignIn(token);
	}

	private async completeSignIn(token: string | undefined): Promise<void> {
		if (!token) {
			this.redirectToLoginWithError("exchange_failed");
			return;
		}

		try {
			await AuthService.exchangeSsoToken(token);
			this.navTo("home", {}, true);
		} catch (error) {
			void error;
			this.redirectToLoginWithError("exchange_failed");
		}
	}

	private redirectToLoginWithError(reason: string): void {
		sessionStorage.setItem(SSO_ERROR_STORAGE_KEY, reason);
		this.navTo("login", {}, true);
	}
}
